import { call, put, select, takeEvery } from "typed-redux-saga";
import { get } from "lodash-es";
import { configurationTargetSelectors } from "../configurationTarget/configurationTargetSlice";
import { UserSettingField } from "../user/user-settings";
import { callApi } from "../sagas";
import {
    configurationTargetSettingsFetched,
    configurationTargetSettingsLoaded,
    configurationTargetSettingsSaveStarted,
    configurationTargetSettingsSaveFinished,
    configurationTargetSettingsSelectors,
} from "./configurationTargetSettingsSlice";

export function* fetchConfigurationTargetSettingsSaga() {
    const appClient = yield* select(configurationTargetSelectors.selectCurrent);

    yield* callApi({
        doApiCall: function* (client) {
            const result = yield* call(async () => client.fetchUserSettingAsync(appClient, UserSettingField.AggregateWaitTime));
            return result;
        },
        onSuccess: function* (result) {
            const value = typeof result === 'number' ? result : (typeof result === 'string' ? parseFloat(result) : null);
            yield* put(configurationTargetSettingsLoaded({ aggregateWaitTimeInSeconds: value }));
        },
        onFailure: function* (error) {
            const errorMessage = `${get(error, 'problem', 'Error')}: ${get(error, 'message', 'Unknown error')}`;
            yield* put(configurationTargetSettingsLoaded({ aggregateWaitTimeInSeconds: null, error: errorMessage }));
        }
    });
}

function* saveConfigurationTargetSettingsSaga() {
    const appClient = yield* select(configurationTargetSelectors.selectCurrent);
    const aggregateWaitTime = yield* select(configurationTargetSettingsSelectors.selectAggregateWaitTime);

    yield* callApi({
        doApiCall: function* (client) {
            if (aggregateWaitTime === null) {
                const result = yield* call(async () => client.deleteUserSettingAsync(appClient, UserSettingField.AggregateWaitTime));
                return result;
            } else {
                const result = yield* call(async () => client.saveUserSettingAsync(appClient, UserSettingField.AggregateWaitTime, aggregateWaitTime));
                return result;
            }
        },
        onSuccess: function* () {
            yield* put(configurationTargetSettingsSaveFinished({ success: true }));
        },
        onFailure: function* (error) {
            const errorMessage = `${get(error, 'problem', 'Error')}: ${get(error, 'message', 'Unknown error')}`;
            yield* put(configurationTargetSettingsSaveFinished({ success: false, error: errorMessage }));
        }
    });
}

export function* watchFetchConfigurationTargetSettingsSaga() {
    yield* takeEvery(configurationTargetSettingsFetched, fetchConfigurationTargetSettingsSaga);
}

export function* watchSaveConfigurationTargetSettingsSaga() {
    yield* takeEvery(configurationTargetSettingsSaveStarted, saveConfigurationTargetSettingsSaga);
}

export function getWatchesForConfigurationTargetSettingsSagas() {
    return [
        watchFetchConfigurationTargetSettingsSaga(),
        watchSaveConfigurationTargetSettingsSaga(),
    ];
}
